import React from 'react';
import { RegisterForm } from '../../components/RegisterForm';

export function RegisterPage() {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <RegisterForm />
    </div>
  );
}
